module.exports = __webpack_public_path__ + "static/2-a90ba277a7eee909006357a39e02a294.jpg";